<template>
  <svg :class="clss">
    <defs>
      <clipPath id="squircle" clipPathUnits="objectBoundingBox">
        <path d="M .5 0 C .1 0 0 .1 0 .5 0 .9 .1 1 .5 1 .9 1 1 .9 1 .5 1 .1 .9 0 .5 0 Z"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script type="text/javascript">
export default {
  name: 'Squircle',
  props: {
    clss: {
      type: String,
      required: true
    }
  }
}
</script>
